/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Office
 */
export interface Office {
    /**
     * 
     * @type {string}
     * @memberof Office
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof Office
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Office
     */
    description?: string | null;
}

/**
 * Check if a given object implements the Office interface.
 */
export function instanceOfOffice(value: object): value is Office {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OfficeFromJSON(json: any): Office {
    return OfficeFromJSONTyped(json, false);
}

export function OfficeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Office {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function OfficeToJSON(json: any): Office {
    return OfficeToJSONTyped(json, false);
}

export function OfficeToJSONTyped(value?: Office | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
    };
}

